import React from "react";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';


function ConfirmatoryModal(props) {
    return (
        <Modal
            show={props.show} onHide={props.onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >

            <Modal.Body>
                <Container>
                    <Row className="modal-row">
                        <Col xs={12} md={6}>
                            {props.actionname.name}
                        </Col>
                        <Col xs={6} md={3}>
                            <Button className="confirm-btn" onClick={props.confirmationfunction}>Igen</Button>
                        </Col>
                        <Col xs={6} md={3}>
                            <Button onClick={props.onHide} className="close-btn"> <span className="nyil">&#60;</span> Mégse</Button>

                        </Col>
                    </Row>

                </Container>
            </Modal.Body>

        </Modal>
    );
}

export default ConfirmatoryModal;